module.exports = __webpack_public_path__ + "static/media/camera_view_center.565ea407.svg";